import {
  BussinessTypeRangeLives1Tokens,
  BussinessTypeRangeLives2Tokens,
  IndividualWithShortageTokens,
  IndividualWithShortageNorthEastTokens,
} from '../../../utils/Enums/Tokens';
export interface Plan {
  type?: string;
  name: string;
  iconSource: string;
  category: Category[];
  covers: string[];
  coversPlus?: string[];
  shortage?: string;
  typeRangeLives?: number;
}

interface Category {
  type: string;
  priceNE: string;
  priceAll: string;
  price: string;
  token: string;
  tokenNe: string;
  tokenNeCC: string;
}

export const personalPlans: Plan[] = [
  // {
  //   name: 'OdontoClínico',
  //   type: 'Plano Universitário',
  //   iconSource: '/assets/images/icons/planos/clinico.svg',
  //   category: [
  //     {
  //       type: 'Com Carencia',
  //       priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}PE/${IndividualWithShortageNorthEastTokens.UNI}`,
  //       priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}DF/${IndividualWithShortageTokens.UNI}`,
  //       price: '',
  //       token: IndividualWithShortageTokens.UNI, // 709
  //     },
  //   ],
  //   covers: [
  //     'Limpeza',
  //     'Restauração',
  //     'Tratamento de Canal',
  //     'Extrações',
  //     'Raio X',
  //     'Emergência 24h',
  //     'Prótese',
  //     '+ 200 procedimentos',
  //   ],
  // },
  {
    name: 'OdontoClínico',
    iconSource: '/assets/images/icons/planos/clinico.svg',
    category: [
      {
        type: 'Com Carencia',
        priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}PE/${IndividualWithShortageNorthEastTokens.CLINICO}`,
        priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}DF/${IndividualWithShortageTokens.CLINICO}`,
        price: '',
        token: IndividualWithShortageTokens.CLINICO, // 709
        tokenNe: IndividualWithShortageNorthEastTokens.CLINICO,
        tokenNeCC: IndividualWithShortageNorthEastTokens.CLINICO_AN,
      },
    ],
    covers: [
      'Limpeza',
      'Restauração',
      'Tratamento de Canal',
      'Extrações',
      'Raio X',
      'Emergência 24h',
      'Prótese',
      '+ 200 procedimentos',
    ],
  },
  {
    name: 'OdontoDoc',
    iconSource: '/assets/images/icons/planos/doc.svg',
    category: [
      {
        type: 'Com Carencia',
        priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}PE/${IndividualWithShortageNorthEastTokens.DOC}`,
        priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}DF/${IndividualWithShortageTokens.DOC}`,
        price: '',
        token: IndividualWithShortageTokens.DOC, // 791
        tokenNe: IndividualWithShortageNorthEastTokens.DOC,
        tokenNeCC: IndividualWithShortageNorthEastTokens.DOC_AN,
      },
    ],
    covers: ['+ Documentação para aparelho', '+ Aparelho metálico'],
    coversPlus: ['Todas coberturas do plano <b>Clínico</b>'],
  },
  {
    name: 'OdontoOrto',
    iconSource: '/assets/images/icons/planos/orto.svg',
    category: [
      {
        type: 'Com Carencia',
        priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}PE/${IndividualWithShortageNorthEastTokens.ORTO}`,
        priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}DF/${IndividualWithShortageTokens.ORTO}`,
        price: '',
        token: IndividualWithShortageTokens.ORTO, // 713
        tokenNe: IndividualWithShortageNorthEastTokens.ORTO,
        tokenNeCC: IndividualWithShortageNorthEastTokens.ORTO_AN,
      },
    ],
    covers: ['+ Manutenção Aparelho', '+ Clareamento caseiro'],
    coversPlus: ['Todas coberturas do plano <b>Doc</b>'],
  },
  {
    name: 'OdontoPrótese',
    iconSource: '/assets/images/icons/planos/protese.svg',
    category: [
      {
        type: 'Com Carencia',
        priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}PE/${IndividualWithShortageNorthEastTokens.PROTESE}`,
        priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}DF/${IndividualWithShortageTokens.PROTESE}`,
        price: '',
        token: IndividualWithShortageTokens.PROTESE, //796
        tokenNe: IndividualWithShortageNorthEastTokens.PROTESE,
        tokenNeCC: IndividualWithShortageNorthEastTokens.PROTESE_AN,
      },
    ],
    covers: [
      '+ Clareamento caseiro',
      '+ Prótese total',
      '+ Prótese removível',
      '+ Placa de bruxismo',
    ],
    coversPlus: ['Todas coberturas do plano <b>Clínico</b>'],
  },
  {
    name: 'OdontoKids',
    iconSource: '/assets/images/icons/planos/kids.svg',
    category: [
      {
        type: 'Com Carencia',
        priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}PE/${IndividualWithShortageNorthEastTokens.KIDS}`,
        priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_INDIVIDUAL}DF/${IndividualWithShortageTokens.KIDS}`,
        price: '',
        token: IndividualWithShortageTokens.KIDS, //937
        tokenNe: IndividualWithShortageNorthEastTokens.KIDS,
        tokenNeCC: IndividualWithShortageNorthEastTokens.KIDS_AN,
      },
    ],
    covers: [
      'Limpeza',
      'Restaurações',
      'Tratamento de Canal',
      'Extrações',
      'Bloco metálico',
      'Coroa Metálica',
      'Coroa em Resina Dentes Anteriores',
      '+ 200 procedimentos',
    ],
    coversPlus: [],
  },
];

export const businessPlans: Plan[] = [
  {
    name: 'OdontoClínico',
    iconSource: '/assets/images/icons/planos/clinico.svg',
    category: [
      {
        type: '2 a 29 Vidas',
        priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}PE/${BussinessTypeRangeLives1Tokens.CLINICO_NE}`,
        priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}DF/${BussinessTypeRangeLives1Tokens.CLINICO}`,
        price: '',
        token: BussinessTypeRangeLives1Tokens.CLINICO,
        tokenNe: BussinessTypeRangeLives1Tokens.CLINICO_NE,
        tokenNeCC: BussinessTypeRangeLives1Tokens.CLINICO_NE,
      },
    ],
    covers: [
      'Limpeza',
      'Restaurações',
      'Tratamento de Canal',
      'Extrações',
      'Bloco metálico',
      'Coroa Metálica',
      'Coroa em resina dentes anteriores',
      '+ 200 procedimentos',
    ],
    shortage: 'Prótese: 180 dias',
    typeRangeLives: 1,
  },
  {
    name: 'OdontoDoc',
    iconSource: '/assets/images/icons/planos/doc.svg',
    category: [
      {
        type: '2 a 29 Vidas',
        priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}PE/${BussinessTypeRangeLives1Tokens.DOC_NE}`,
        priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}DF/${BussinessTypeRangeLives1Tokens.DOC}`,
        price: '',
        token: BussinessTypeRangeLives1Tokens.DOC,
        tokenNe: BussinessTypeRangeLives1Tokens.DOC_NE,
        tokenNeCC: BussinessTypeRangeLives1Tokens.DOC_NE,
      },
    ],
    covers: ['+ Documentação para aparelho', '+ Aparelho metálico'],
    coversPlus: ['Todas as coberturas do plano Clínico'],
    shortage: 'Prótese: 180 dias',
    typeRangeLives: 1,
  },
  {
    name: 'OdontoOrto',
    iconSource: '/assets/images/icons/planos/orto.svg',
    category: [
      {
        type: '2 a 29 Vidas',
        priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}PE/${BussinessTypeRangeLives1Tokens.ORTO_NE}`,
        priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}DF/${BussinessTypeRangeLives1Tokens.ORTO}`,
        price: '',
        token: BussinessTypeRangeLives1Tokens.ORTO,
        tokenNe: BussinessTypeRangeLives1Tokens.ORTO_NE,
        tokenNeCC: BussinessTypeRangeLives1Tokens.ORTO_NE,
      },
    ],
    covers: [
      '+ Aparelho metálico',
      '+ Manutenções mensais',
      '+ Clareamento caseiro',
    ],
    coversPlus: ['+ Manutenção Aparelho', '+ Clareamento caseiro'],
    shortage: 'Prótese: 180 dias',
    typeRangeLives: 1,
  },
  {
    name: 'OdontoClínico',
    iconSource: '/assets/images/icons/planos/clinico.svg',
    category: [
      {
        type: '30 a 99 Vidas',
        priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}PE/${BussinessTypeRangeLives2Tokens.CLINICO_NE}`,
        priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}DF/${BussinessTypeRangeLives2Tokens.CLINICO}`,
        price: '',
        token: BussinessTypeRangeLives2Tokens.CLINICO,
        tokenNe: BussinessTypeRangeLives2Tokens.CLINICO_NE,
        tokenNeCC: BussinessTypeRangeLives2Tokens.CLINICO_NE,
      },
    ],
    covers: [
      'Limpeza',
      'Restauração',
      'Tratamento de Canal',
      'Extrações',
      'Raio X',
      'Emergência 24h',
      'Prótese',
      '+ 200 procedimentos',
    ],
    shortage: 'Prótese: 180 dias',
    typeRangeLives: 2,
  },
  {
    name: 'OdontoDoc',
    iconSource: '/assets/images/icons/planos/doc.svg',
    category: [
      {
        type: '30 a 99 Vidas',
        priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}PE/${BussinessTypeRangeLives2Tokens.DOC_NE}`,
        priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}DF/${BussinessTypeRangeLives2Tokens.DOC}`,
        price: '',
        token: BussinessTypeRangeLives2Tokens.DOC,
        tokenNe: BussinessTypeRangeLives2Tokens.DOC_NE,
        tokenNeCC: BussinessTypeRangeLives2Tokens.DOC_NE,
      },
    ],
    covers: [
      'Limpeza',
      'Restauração',
      'Tratamento de Canal',
      'Extrações',
      'Raio X',
      'Emergência 24h',
      'Prótese',
      '+ 200 procedimentos',
    ],
    coversPlus: ['+ Documentação para aparelho', '+ Aparelho metálico'],
    shortage: 'Prótese: 180 dias',
    typeRangeLives: 2,
  },
  {
    name: 'OdontoOrto',
    iconSource: '/assets/images/icons/planos/orto.svg',
    category: [
      {
        type: '30 a 99 Vidas',
        priceNE: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}PE/${BussinessTypeRangeLives2Tokens.ORTO_NE}`,
        priceAll: `${process.env.REACT_APP_OG_GET_PLAN_PRICE_COMPANY}DF/${BussinessTypeRangeLives2Tokens.ORTO}`,
        price: '',
        token: BussinessTypeRangeLives2Tokens.ORTO,
        tokenNe: BussinessTypeRangeLives2Tokens.ORTO_NE,
        tokenNeCC: BussinessTypeRangeLives2Tokens.ORTO_NE,
      },
    ],
    covers: [
      'Limpeza',
      'Restauração',
      'Tratamento de Canal',
      'Extrações',
      'Raio X',
      'Emergência 24h',
      'Prótese',
      '+ 200 procedimentos',
    ],
    coversPlus: [
      '+ Aparelho metálico',
      '+ Manutenções mensais',
      '+ Clareamento caseiro',
    ],
    shortage: 'Prótese: 180 dias',
    typeRangeLives: 2,
  },
];
